module.exports = __webpack_public_path__ + "static/media/mindshare.68f49a33.jpg";